<template>
<div style="height: 100%;">

	<image-panel v-if="uploadUrl && isImage"
		:expand-on-click="true"
		:image-url="uploadUrl"
		:expand-url="uploadUrl"
		:readonly="readonly"
		:value="uploadObject"
		v-on:deleteImg="deleteFile"
		v-on:rotate="rotateImage">
	</image-panel>

	<iframe v-else-if="uploadUrl && isPdf"
		width="100%"
		height="300"
		:src="uploadUrl">
	</iframe>

	<div v-else-if="uploadUrl && uploadObject" class="filename-container" :class="{editable: !readonly}" v-on:click="deleteFile" style="height: 100%;display: flex;align-items: center;">
		{{ uploadObject.original_filename }}
		<i v-if="!readonly" class="fa fa-trash icon-button"></i>
	</div>

	<div v-if="helpMessage && !readonly && !uploadUrl" class="text-muted">{{ helpMessage }}</div>

	<upload-field v-if="!readonly && (!uploadUrl || showUploader)"
		style-type='box'
		:target="apiModel+'/save'"
		:icons="icons"
		:upload-msg="uploadMessage"
		:accept="acceptFiles"
		v-on:uploaded="uploaded"
		v-on:uploadStarted="$emit('uploadStarted')">
	</upload-field>

	<div v-else-if="!readonly && !showUploader" class="text-center">
		<a href="#" v-on:click.prevent="showUploader = true">Change...</a>
	</div>

</div>
</template>
<script type="text/javascript">
import ImagePanel from "@/components/ImagePanel"
import UploadField from "@/components/UploadField"

export default {
	name: "UploadFieldWithPanel",
	components: {
		ImagePanel,
		UploadField,
	},
	props: [
		"value",         // v-model of upload content (UploadImage, UploadFile, etc)
		"apiModel",      // model to upload content to
		"uploadType",    // accepts 'image', 'pdf', 'image/pdf', 'file'
		"uploadMessage", // message displayed after upload
		"helpMessage",
		"readonly"
	],
	data() {
		return {
			uploadObject: null,
			uploadUrl: "",
			showUploader: false,
			
		}
	},
	watch: {
		value() {
			this.setValue()
		}
	},
	computed: {
		isPdf() {
			if (!this.uploadObject)
				return false

			let split = this.uploadObject.filename.split(".")

			let ext = split[split.length - 1]

			if (ext == 'pdf')
				return true

			else
				return false
		},
		isImage() {
			if (!this.uploadObject)
				return false

			let split = this.uploadObject.filename.split(".")

			let ext = split[split.length - 1].toLowerCase()

			return this.isImageExtension(ext)
		},
		icons() {
			if (this.uploadType == 'image') 
				return ["fa-plus","fa-camera"]
			
			else if (this.uploadType == 'pdf') 
				return ["fa-plus","fa-file-pdf"]
			
			else if (this.uploadType == 'image/pdf') 
				return ["fa-plus","fa-camera","fa-file-pdf"]
			
			else if (this.uploadType == 'file') 
				return ["fa-plus","fa-upload"]
		},
		acceptFiles() {
			if (this.uploadType == 'image') 
				return "image/*"
			
			else if (this.uploadType == 'pdf') 
				return ".pdf"
			
			else if (this.uploadType == 'image/pdf') 
				return "image/*,.pdf"
			
			else if (this.uploadType == 'file') 
				return "documents/images"
		}
	},
	methods: {
		setValue() {
			if (typeof(this.value) == 'object' && this.value && "filename" in this.value && this.value.filename) {
				this.uploadUrl = this.createUploadUrl(this.value.filename)
				this.uploadObject = this.value
			}
			else {
				this.uploadUrl = ""
				this.showUploader = true
			}
		},	
		createUploadUrl(filename) {
			let url = window.apiRoot+"resources/"
			if (this.uploadType == "image" || this.uploadType == 'image/pdf')	{
				if (this.apiModel == 'ProfileImage')
					url += "profile-images/"
				else if (this.apiModel == 'ReceiptImage')
					url += "receipt-images/"
				else
					url += "images/"
			}
			else 
				url += "files/"

			url += this.$store.sessionToken+"/"+filename

			/*
			if (this.apiModel != 'UploadFile')
				url += "/"+this.apiModel
			*/

			url += "?v="+Math.random()

			let ext = filename.split(".")
			if (ext[ext.length-1] == 'pdf')
				url += "&display=true"

			return url
		},
		uploaded(response) {
			this.uploadObject = response.data

			this.uploadUrl = this.createUploadUrl(response.data.filename)
			this.showUploader = false

			this.$emit("uploaded",response)
			this.$emit("input",response.data)
		},
		deleteFile() {
			let vm = this

			if (!this.readonly) {

				this.spinner(true)

				let payload = {
					id: this.uploadObject.id
				}

				this.postData(this.apiModel+"/delete",payload).then(response => {
					vm.spinner(false)

					if (response.success) {
						vm.alertSuccess("File deleted")
						vm.$emit("deleted")

						vm.$emit("input",false)

						vm.uploadUrl = false
					}
				})
			}
		},
		rotateImage(direction) {
			let payload = {
				id: this.uploadObject.id,
				rotate_direction: direction
			}

			let vm = this

			this.postData(this.apiModel+"/rotate",payload).then(response => {
				//strip query string, and then add another random one

				let imageUrl = vm.uploadUrl.split("?")[0]

				vm.uploadUrl = imageUrl+"?"+Math.random()

				vm.$forceUpdate()
			})
		}
	},
	created() {
		this.setValue()
	}
}

</script>

<style type="text/css" scoped>
	.filename-container.editable {
		display: flex;
		justify-content: space-between;
		cursor: pointer;
	}

	.filename-container i {
		display: none;
	}

	.filename-container.editable:hover i {
		display: inline;
	}
</style>